/**
 * Routes shorter than this are classified as 'short' and sent to OSRM first.
 * OSRM handles short Russian routes well but tends to cut through Kazakhstan/Mongolia
 * on trans-Siberian distances, so longer routes skip directly to ORS.
 */
export const SHORT_ROUTE_THRESHOLD_KM = 1200

/**
 * ORS cannot route a single segment longer than this, so orsRoute() splits the
 * route into chunks.
 */
export const MAX_ORS_SEGMENT_KM = 5900

/**
 * Waypoints inserted along the Trans-Siberian corridor when a long direct route
 * is requested and ORS needs guidance to stay on Russian roads.
 */
export const TRANS_SIBERIAN_CORRIDOR: [number, number][] = [
  [55.0302, 73.3122],  // Omsk
  [55.0084, 82.9357],  // Novosibirsk
  [56.0153, 92.8932],  // Krasnoyarsk
  [52.2869, 104.305],  // Irkutsk
  [52.0338, 113.5009], // Chita
  [48.4808, 135.0928], // Khabarovsk
]

/**
 * ORS ISO 3166-1 numeric country codes to avoid: Kazakhstan, China, Mongolia,
 * and CIS neighbours that OSRM incorrectly routes through for long Russian routes.
 */
export const ORS_AVOID_COUNTRIES = [398, 156, 496, 408, 112, 804, 268, 31, 428, 233, 440, 616, 246, 578]
